import React from "react";

import InfoModal from "../modals/InfoModal";

function Header() {
  return (
    <header>
      <div className="header-content">
        <div className="title-section">
          <h1>Connections</h1>
          <p className="byline">BY X&J</p>
        </div>
        <div className="info-icon">
          <InfoModal />
        </div>
      </div>
    </header>
  );
}

export default Header;
